import React from "react";
import { Link } from "react-router-dom";
import ActivityFooter from "../common/ActivityFooter";

const BurndownChartPage3 = ({ color, onBack, onContinue }) => {
  return (
    <div>
      <div className="content-area flex-grow">
        <div className="bg-gallery px-15 sm:px-50 lg:px-15 py-11">
          <div className="lg:max-w-520 mx-auto">
            <h1 className="uppercase font-bold text-gray-800 my-0 text-md">
              CREATE AN BURNDOWN CHART
            </h1>
          </div>
        </div>
        <div className="inner-content px-15 sm:px-50 lg:px-15 pt-19 mx-auto pb-25 lg:pb-8 text-gray-800">
          <p>
            In column B, enter the planned effort, or what you hope to have had
            accomplished by this date. You can use your{" "}
            <a
              className="term-link text-orange-100 hover:text-gray-800"
              href="/"
              data-term="SAMPLE DEF"
            >
              project schedule
            </a>{" "}
            to help guide you.
          </p>
        </div>
        <div className="row flex justify-center sm:-mx-35">
          <Link
            to="/app/activity/project-schedule"
            className="btn-lg flex px-10 pt-11 pb-9 sm:pt-6 sm:pb-4 uppercase bg-orange-100 text-white hover:bg-gray-900 hover:text-white font-secondary font-bold mx-5 mb-5"
          >
            <strong className="flex items-center font-bold">
              SHOW ME HOW TO CREATE A PROJECT SCHEDULE
            </strong>
          </Link>
        </div>
        <div className="text-center pt-33">
          <img
            className="inline-block align-top"
            src="images/img87.jpg"
            alt=" description"
            width="375"
            height="220"
          />
        </div>
      </div>

      <ActivityFooter color={color} onBack={onBack} onContinue={onContinue} />
    </div>
  );
};

export default BurndownChartPage3;
